module.exports = __webpack_public_path__ + "static/media/clients-02.e54005bf.svg";